module.exports = __webpack_public_path__ + "img/shoubao.b97a78c7.jpg";